import axios, { AxiosRequestConfig } from "axios";
import { buscaGrupo, todoGrupo } from "../types/grupo";

export const getGrupos = async (token: string): Promise<buscaGrupo[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupo`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar grupos:", error);
    throw error;
  }
};

export const getGrupoById = async (
  token: string,
  id: string
): Promise<todoGrupo> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupo/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar grupo:", error);
    throw error;
  }
};

export const createGrupo = async (token: string, grupoData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupo`;
    const response = await axios.post(url, grupoData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar grupo:", error);
    throw error;
  }
};

export const updateGrupo = async (
  token: string,
  id: string,
  grupoData: {
    nome_grupo: string;
    grupo_tipo_lancamento?: string | null;
  }
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupo/${id}`;
    const response = await axios.put(url, grupoData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar grupo:", error);
    throw error;
  }
};

export const deleteGrupo = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupo/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir grupo:", error);
    throw error;
  }
};
